import { CallVm } from '../classes/callVm';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';
import { CallHistoryVm } from '../classes/callHistoryVm';

export class CallsApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async getCallsHistory(
    pageNumber: number,
    pageSize: number,
    isDescending: boolean,
    orderBy: string,
  ): Promise<CallHistoryVm> {
    const response: AxiosResponse<
      AppResponse<CallVm[]>
    > = await AuthorizedApiClient.get(
      '/call/GetCallHistory?'
      + 'pageNumber=' + pageNumber
      + '&pageSize=' + pageSize
      + '&IsDescending=' + isDescending
      + '&orderBy=' + orderBy,
    );

    const appResponse: AppResponse<CallVm[]> = response.data;
    if (appResponse.IsSuccess) {
      const totalCount: number = (JSON.parse(response.headers['lc-pagination'])).TotalCount;
      const totalDuration: number = (JSON.parse(response.headers['lc-pagination'])).TotalDuration;
      const returnData: CallHistoryVm = {
        calls: appResponse.Result,
        totalCount,
        totalDuration,
      };
      return returnData;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

}
